import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ChamadoFranquiaChatComponent } from './chamado-franquia-chat.component';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    {path:':id', component: ChamadoFranquiaChatComponent}
  ])],
  exports: [RouterModule]
})
export class ChamadoFranquiaChatRoutingModule { }
